import React, { useContext } from "react";
import { FaTemperatureHigh, FaTemperatureLow, FaTint, FaTshirt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "../TrainingGlobal.css";
import BannerImage from "./heat.jpg";

const HeatColdStress: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/heat-stress');
    } else {
      navigate('/login', { state: { from: '/booking/heat-stress' } });
    }
  };

  return (
    <div className="training-page">
      <div className="training-max-width">

        {/* --- HERO --- */}
        <div className="training-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Environmental Health</span>
          <h1 className="hero-title">Heat & Cold Stress</h1>
          <p className="hero-subtitle">
            From furnace maintenance to cold storage work.
            Understanding thermoregulation and preventing thermal shock.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Heat Stress Dangers</h2>
              <p className="article-text">
                The body cools by sweating. In high humidity or under heavy PPE, sweat can't evaporate.
                Core temperature rises, leading to:
                <br /><strong>Heat Exhaustion:</strong> Heavy sweating, dizziness, nausea.
                <br /><strong>Heat Stroke:</strong> No sweating, hot skin, confusion, seizures. Medical Emergency.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Cold Stress Dangers</h2>
              <p className="article-text">
                Blood vessels constrict to keep core warm, sacrificing extremities.<br />
                <strong>Hypothermia:</strong> Shivering stops, confusion, slurred speech.<br />
                <strong>Frostbite:</strong> White/waxy skin, numbness. Don't rub frostbitten areas!
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Acclimatization</h2>
              <p className="article-text">
                The body needs time to adapt. New workers should start at 20% exposure and increase
                gradually over 5-7 days. Same applies after long holidays.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Prevention Controls</h2>
              <p className="article-text">
                <ul style={{ paddingLeft: '20px', color: '#ccc', lineHeight: '1.8' }}>
                  <li><strong>Water:</strong> Drink 1 cup every 15-20 mins (Heat).</li>
                  <li><strong>Rest:</strong> Frequent breaks in shade/warmth.</li>
                  <li><strong>Clothing:</strong> Breathable layers vs Insulated layers.</li>
                  <li><strong>Buddy System:</strong> Monitor each other for symptoms.</li>
                </ul>
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Survival Tips</h4>
              <ul className="key-list">
                <li><FaTint className="check-icon" /> Hydrate before thirsty</li>
                <li><FaTshirt className="check-icon" /> Dress for conditions</li>
                <li><FaTemperatureHigh className="check-icon" /> Know Heat Index</li>
                <li><FaTemperatureLow className="check-icon" /> Watch Wind Chill</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Stay Safe</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Don't let the weather kill you. Train today.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default HeatColdStress;
